import { Popover } from '../Popover';
import { Tooltip } from '../Tooltip';
/**
 * Returns the default offset value for the overlay based on the overlay child reference.
 * @param overlayChildRef - The reference to the overlay child element.
 * @returns The default offset value for the overlay.
 */ export const getDefaultOffset = (overlayChildRef)=>{
    if (!overlayChildRef) return [
        0,
        0
    ];
    if (overlayChildRef.classList.contains('popover')) return Popover.DEFAULT_OFFSET;
    if (overlayChildRef.classList.contains('tooltip')) return Tooltip.DEFAULT_OFFSET;
    return [
        0,
        0
    ];
};
